import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

const defaultSorted = [{ dataField: 'code', order: 'desc' }];
const List = (props) => {
  const { entities, totalCount, intl, setQueryParams, listLoading } = props;
  const finDateLabel = intl.formatMessage({ id: 'FINANCE.LABEL.FINDATE' });
  const orderAmountLabel = intl.formatMessage({
    id: 'FINANCE.PURCHASE.LABEL.ORDERAMOUNT',
  });
  const rewardAmountLabel = intl.formatMessage({
    id: 'FINANCE.PURCHASE.LABEL.REWARDAMOUNT',
  });
  const cardAmountLabel = intl.formatMessage({
    id: 'FINANCE.PURCHASE.LABEL.CARDAMOUNT',
  });
  const cardBalanceLabel = intl.formatMessage({
    id: 'FINANCE.PURCHASE.LABEL.CARDBALANCE',
  });

  // Table columns
  const columns = [
    {
      dataField: 'finDate',
      text: finDateLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },
    {
      dataField: 'orderAmount',
      text: orderAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.PriceColumnFormatter,
    },
    {
      dataField: 'rewardAmount',
      text: rewardAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
    },
    {
      dataField: 'cardAmount',
      text: cardAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-center',
      formatter: columnFormatters.PriceColumnFormatter,
    },
    {
      dataField: 'cardBalance',
      text: cardBalanceLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPage: 400,
    page: 1,
  };
  return (
    <BootstrapTable
      key='financePurchaseList'
      wrapperClasses='table-responsive'
      bordered={true}
      classes='table table-head-custom table-vertical-center overflow-hidden'
      bootstrap4
      remote
      keyField='finDate'
      data={entities === null ? [] : entities}
      columns={columns}
      defaultSorted={defaultSorted}
    >
      <PleaseWaitMessage entities={entities} />
      <NoRecordsFoundMessage entities={entities} />
    </BootstrapTable>
  );
};

export default injectIntl(List);
